/**
 * Valores de referência do trabalho em altura, num arquivo de dados, longe da
 * lógica: o instrutor corrige um número aqui sem mexer em mais nada.
 *
 * TODOS os valores abaixo são PROVISÓRIOS (`confirmado: false`): vêm de
 * práticas comuns de mercado e esperam a validação do instrutor e a conferência
 * no texto oficial da NR-35 e das normas técnicas dos equipamentos. A tela
 * mostra o aviso enquanto houver valor não confirmado.
 */

export interface ReferenciaAltura {
  readonly valor: number
  readonly unidade: 'm' | 'kN' | ''
  /** De onde vem o número, e o que falta para confirmá-lo. */
  readonly origem: string
  /** `true` só depois de o instrutor validar. */
  readonly confirmado: boolean
}

export const REFERENCIAS_ALTURA = {
  /** Acima desta altura do nível inferior, com risco de queda, a NR-35 se aplica. */
  alturaMinimaNr35M: {
    valor: 2,
    unidade: 'm',
    origem: 'NR-35: trabalho em altura é o realizado acima de 2 m do nível inferior com risco de queda. Conferir no texto oficial vigente.',
    confirmado: false,
  },
  /** Comprimento padrão do talabarte, com conectores. */
  comprimentoTalabartePadraoM: {
    valor: 1.8,
    unidade: 'm',
    origem: 'Prática de mercado (talabartes de até 1,8 m com conectores). Conferir a norma do equipamento e o fabricante.',
    confirmado: false,
  },
  /** Quanto o absorvedor de energia se abre até parar a queda. */
  aberturaAbsorvedorPadraoM: {
    valor: 1,
    unidade: 'm',
    origem: 'Prática de mercado (abertura máxima em torno de 1 m a 1,2 m). Conferir o fabricante.',
    confirmado: false,
  },
  /** Do engate dorsal aos pés, de um trabalhador adulto em pé. */
  engateAosPesPadraoM: {
    valor: 1.45,
    unidade: 'm',
    origem: 'Altura aproximada do engate dorsal de um adulto. Depende do trabalhador e do cinturão; o instrutor define.',
    confirmado: false,
  },
  /** Folga que sobra entre os pés, depois da queda, e o chão ou o obstáculo. */
  margemSegurancaPadraoM: {
    valor: 1,
    unidade: 'm',
    origem: 'Valor didático; o instrutor define a margem adotada.',
    confirmado: false,
  },
  /** Queda livre acima da qual o talabarte sem absorvedor não é aceitável. */
  quedaLivreSemAbsorvedorM: {
    valor: 0.6,
    unidade: 'm',
    origem: 'Regra didática de que queda livre acima de cerca de 0,6 m exige absorvedor de energia. Conferir no texto da NR-35 e nas normas dos equipamentos.',
    confirmado: false,
  },
  /** Fator de queda a partir do qual o app avisa que a ancoragem é desfavorável. */
  fatorDeQuedaDeAlerta: {
    valor: 1,
    unidade: '',
    origem: 'Fator de queda acima de 1 (ancoragem abaixo do engate) agrava a força no corpo; o fator 2 é o máximo.',
    confirmado: false,
  },
  /** Força máxima que o sistema pode transmitir ao corpo ao parar a queda. */
  forcaMaximaNoCorpoKN: {
    valor: 6,
    unidade: 'kN',
    origem: 'Limite de 6 kN no corpo usado nas normas de absorvedor de energia e de sistemas de retenção de queda. Conferir na norma do equipamento e no texto da NR-35.',
    confirmado: false,
  },
} as const satisfies Record<string, ReferenciaAltura>

export const HA_REFERENCIA_NAO_CONFIRMADA = Object.values(REFERENCIAS_ALTURA).some((r) => !r.confirmado)

export const AVISO_VALORES_PROVISORIOS =
  'Valores de referência provisórios: o instrutor ainda precisa validar os números e conferi-los no texto da NR-35 e nas normas dos equipamentos.'
